import { render, staticRenderFns } from "./dgcodeDetail.vue?vue&type=template&id=dc922374&scoped=true"
import script from "./dgcodeDetail.vue?vue&type=script&lang=js"
export * from "./dgcodeDetail.vue?vue&type=script&lang=js"
import style0 from "./dgcodeDetail.vue?vue&type=style&index=0&id=dc922374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc922374",
  null
  
)

export default component.exports